
import { Vue, Component, Prop } from 'vue-property-decorator';
import Theme from '@/components/Theme.vue';
import { ThemeData } from '../types';
import { MutationType, RouteName } from '@/enums';

@Component({
	components: {
		Theme
	}
})
export default class ChapterSurvey extends Vue {
	private currentThemeIndex: number = 0;
	private themes: ThemeData[] = Object.values(this.$store.state.currentChapter.themes);

	private get currentTheme(): ThemeData {
		return this.themes[this.currentThemeIndex];
	}

	mounted(): void {
		this.$store.commit(MutationType.SET_CURRENT_THEME, this.currentTheme);
	}

	private onThemeFinished(): void {
		this.$store.commit(MutationType.PUSH_FINISHED_THEME, this.currentTheme.id);
		if (this.currentThemeIndex < this.themes.length - 1) {
			this.currentThemeIndex++;
			this.$store.commit(MutationType.SET_CURRENT_THEME, this.currentTheme);
		} else {
			this.backToOverview();
		}
	}

	private backToOverview(): void {
		this.$router.push({
			name: RouteName.OVERVIEW
		});
	}
}
